import Vue from "vue";
import Router from "vue-router";
const Index = () => import("@/views/index");
const Index_ue = () => import("@/views/index_ue");
const Index_Sass = () => import("@/views/sass_index");
const mapTest = () => import("@/views/map/map");
const IndexSet = () => import("@/views/indexSet");
const Index_2d = () => import("@/views/index_2d");
const largeSize = () => import("@/views/largeSize/index");
const Index_2ds = () => import("@/views/index_2ds");
const Login = () => import("@/views/user/login");
const userSet = () => import("@/views/user/set");
const Main = () => import("@/views/main");
const Iframe = () => import("@/views/iframe");
const realtimeTrack = () => import("@/views/tracing/realtimeTrack");
const realtimeTrack_ue = () => import("@/views/tracing/realtimeTrack_ue");
const realtimeTrack_2d = () => import("@/views/tracing/realtimeTrack-2d");
const realtimeTrack_2ds = () => import("@/views/tracing/realtimeTrack-2ds");
const realtimeLocation = () => import("@/views/tracing/realtimeLocation");
const realtimeLocationTracking = () => import("@/views/tracing/realtimeLocationTracking");
const moreConfigurationSystem = () => import("@/views/log/moreConfigurationSystem");
const moreConfigurationPerson = () => import("@/views/log/moreConfigurationPerson");
const realtimeLocation_ue = () => import("@/views/tracing/realtimeLocation-ue");
const realtimeLocation_2d = () => import("@/views/tracing/realtimeLocation-2d");
const realtimeLocation_2ds = () => import("@/views/tracing/realtimeLocation-2ds");
const hotMap = () => import("@/views/tracing/hotMap");
const hotMap_2d = () => import("@/views/tracing/hotMap-2d");
const hotMap_2ds = () => import("@/views/tracing/hotMap-2ds");
const riskMap = () => import("@/views/tracing/risk");
const riskMap_2d = () => import("@/views/tracing/risk-2d");
const riskMap_2ds = () => import("@/views/tracing/risk-2ds");
const history = () => import("@/views/tracing/history");
const history_2d = () => import("@/views/tracing/history-2d");
const history_ue = () => import("@/views/tracing/history-ue");
const userManage = () => import("@/views/user/list");
const menuManage = () => import("@/views/menu/menuManage");
const mapConfig = () => import("@/views/map/mapConfig");
const mapList = () => import("@/views/map/mapList");
const beaconList = () => import("@/views/beacon/list");
const beaconList_2ds = () => import("@/views/beacon/list-2ds");
const beaconList_2d = () => import("@/views/beacon/list-2d");
const beaconManage = () => import("@/views/beacon/manage");
const beaconManage_2ds = () => import("@/views/beacon/manage-2ds");
const beaconManage_2d = () => import("@/views/beacon/manage-2d");
const buildingList = () => import("@/views/layer/list");
const layerList = () => import("@/views/layer/layerList");
const layerManage = () => import("@/views/layer/manage");
const stationList = () => import("@/views/station/list");
const stationManage = () => import("@/views/station/manage");
const stationList_2d = () => import("@/views/station/list-2d");
const stationManage_2d = () => import("@/views/station/manage-2d");
const UWBstationList = () => import("@/views/UWBstation/list");
const UWBstationManage = () => import("@/views/UWBstation/manage");
const UWBstationList_2ds = () => import("@/views/UWBstation/list-2ds");
const UWBstationManage_2ds = () => import("@/views/UWBstation/manage-2ds");
const cameraList = () => import("@/views/camera/list");
const cameraManage = () => import("@/views/camera/manage");
const cameraList_2d = () => import("@/views/camera/list-2d");
const cameraManage_2d = () => import("@/views/camera/manage-2d");
const roleManage = () => import("@/views/role/list");
const deptManage = () => import("@/views/dept/list");
const positionManage = () => import("@/views/position/list");
const cardManage = () => import("@/views/card/list");
const dictManage = () => import("@/views/dict/list");
const personAll = () => import("@/views/person/allList");
const staffManage = () => import("@/views/person/staffManage");
const visitorManage = () => import("@/views/person/visitorManage");
const contractorManage = () => import("@/views/person/contractorManage");
const migrantManage = () => import("@/views/person/migrantManage");
const loginLog = () => import("@/views/log/loginLog");
const operLog = () => import("@/views/log/operLog");
const locationLog = () => import("@/views/log/locationLog");
const railList = () => import("@/views/rail/list");
const railList_2ds = () => import("@/views/rail/list-2ds");
const railList_2d = () => import("@/views/rail/list-2d");
const railManage = () => import("@/views/rail/manage");
const railManage_2d = () => import("@/views/rail/manage-2d");
const railManage_2ds = () => import("@/views/rail/manage-2ds");
const riskList = () => import("@/views/risk/list");
const riskManage = () => import("@/views/risk/manage");
const riskList_2d = () => import("@/views/risk/list-2d");
const riskManage_2d = () => import("@/views/risk/manage-2d");
const alarmNoticeSet = () => import("@/views/alarm/alarmNoticeSet");
const sosAlarmNoticeSet = () => import("@/views/alarm/sosAlarmNoticeSet");
const alarmPersonSet = () => import("@/views/alarm/alarmPersonSet");
const alarmPsList = () => import("@/views/alarm/alarmPsList");
const systemInfo = () => import("@/views/system/systemInfo");
const statisticsAlarm = () => import("@/views/statistics/alarm");
const statisticsPerson = () => import("@/views/statistics/person");
const statisticsCar = () => import("@/views/statistics/car");
const carManage = () => import("@/views/car/carList");
const visitorVehicle = () => import("@/views/car/visitorVehicle");
const alarmCarSet = () => import("@/views/alarm/alarmCarSet");
const alarmCarList = () => import("@/views/alarm/alarmCarList");
const watchManage = () => import("@/views/watch/list");
const termManage = () => import("@/views/patrol/termManage");
const locationManage = () => import("@/views/patrol/locationManage");
const locationDispose = () => import("@/views/patrol/locationDispose");
const hiddenDangerManage = () => import("@/views/patrol/hiddenDangerManage");
const patrolClassmanage = () => import("@/views/patrol/patrolClassmanage");
const patrolInspectionTeam = () => import("@/views/patrol/patrolInspectionTeam");
const checkRouteManage = () => import("@/views/patrol/checkRouteManage");
const regionList = () => import("@/views/region/regionList");
const beaconGrouping = () => import("@/views/region/grouping");
const groupingManage_2ds = () => import("@/views/region/groupingManage-2ds");
const regionManage_2d = () => import("@/views/region/manage-2d");
const regionManage = () => import("@/views/region/manage");
const inspectRecord = () => import("@/views/patrol/inspectRecord");
const inspectHistory = () => import("@/views/patrol/inspectRecords");
const carHistory = () => import("@/views/tracing/car-history");
const carHistory_2d = () => import("@/views/tracing/carHistory-2d");
const alarmManage_2d = () => import("@/views/alarm/alarmManage-2d");
const alarmManage_2ds = () => import("@/views/alarm/alarmManage-2ds");
const typeManage = () => import("@/views/task/typeManage");
const configureManage = () => import("@/views/task/configure");
const examineManage = () => import("@/views/task/examine");
const taskRiskManage = () => import("@/views/task/riskManage");
const safeManage = () => import("@/views/task/safeManage");
const urgentManage = () => import("@/views/task/urgent");
const analysis = () => import("@/views/task/analysis");
const deviceManage = () => import("@/views/custody/device");
const recordManage = () => import("@/views/custody/record");
const workMAlarm = () => import("@/views/custody/statistic");
const videoAnalysis = () => import("@/views/custody/videoAnalysis");
const taskAnalyse = () => import("@/views/safe/analyse");
const taskApply = () => import("@/views/safe/apply");
const examineList = () => import("@/views/safe/examineList");
const taskList = () => import("@/views/safe/list");
const taskEvent = () => import("@/views/safe/taskEvent");
const trajectory = () => import("@/views/patrol/trajectory");
const personTime = () => import("@/views/tracing/personTime");
const personTime_2ds = () => import("@/views/tracing/personTime-2ds");
const gateRecord = () => import("@/views/statistics/gateRecord");
const attendanceRecord = () => import("@/views/statistics/attendanceRecord");
const onlineRate = () => import("@/views/statistics/onlineRate");
const systemConfigura = () => import("@/views/configura/systemConfigura");
const statisticsInspect = () => import("@/views/patrol/statisticsAnalysis");
const useVehicle = () => import("@/views/vehicle/useVehicle");
const submitSuccess = () => import("@/views/vehicle/submitSuccess");
const cardDispenserRent = () => import("@/views/vehicle/vehicleCar");
const cardDispenserPerson1 = () => import("@/views/vehicle/vehiclePerson");
const carRecord = () => import("@/views/car/carRecord");
const applyLocation = () => import("@/views/safe/applyLocation");
const drawRail = () => import("@/views/safe/drawRail");
const drillPlan = () => import("@/views/drill/plan");
const drillRecord = () => import("@/views/drill/record");
const emergencyArea = () => import("@/views/drill/emergencyArea");
const broadcast = () => import("@/views/drill/broadcast");
const addCompany = () => import("@/views/add/company");
const areaList = () => import("@/views/region/areaList");
const personHistory = () => import("@/views/tracing/person-history");
const lampList = () => import("@/views/lamp/list");
const lampManage = () => import("@/views/lamp/manage");
const lampGroup = () => import("@/views/lamp/groupList");
const TimeStatistics = () => import("@/views/lamp/TimeStatistics");
const lampTask = () => import("@/views/lamp/task");
const lampAlarm = () => import("@/views/lamp/alarm");
const lampStatistics = () => import("@/views/lamp/statistics");
const cardDispenserManage = () => import("@/views/cardDispenser/manage");
const cardDispenserRecord = () => import("@/views/cardDispenser/record");
const cardDispenserControl = () => import("@/views/cardDispenser/control");
const cardDispenserPerson = () => import("@/views/cardDispenser/cardDispenserPerson");
const cardIsuserStatus = () => import("@/views/cardDispenser/cardIsuserStatus");
const cardRecord = () => import("@/views/cardDispenser/cardRecord");
const recordPerson = () => import("@/views/cardDispenser/recordPerson");
const areaRecord = () => import("@/views/statistics/areaRecord");
const messageLog = () => import("@/views/log/messageLog");
const mapTools = () => import("@/views/map/mapTools");
const CorporateGroupIndex = () => import("@/views/CorporateGroup/index");
const CGM = () => import("@/views/CorporateGroup/manage");
const CGC = () => import("@/views/CorporateGroup/child");
const turnstileManage = () => import("@/views/turnstile/manage");
const sqlBack = () => import("@/views/system/backups");
const tenantList = () => import("@/views/tenant/tenant_list");
const tenantDataSource = () => import("@/views/tenant/tenant_dataSource");
const notFound = () => import("@/views/404/index");
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};
export default new Router({
    mode: "history",
    // base:"/RYDWYY/",
    routes: [
        {
            path: "/addCompany",
            name: "addCompany",
            component: addCompany,
            meta: {
                breadcrumb: []
            }
        },
        {
            path: "/404",
            name: "404",
            component: notFound,
            meta: {
                breadcrumb: []
            }
        },
        {
            path: "/useVehicle",
            component: useVehicle,
            meta: {
                title: "扫码通行",
                breadcrumb: []
            }
        },
        {
            path: "/cardDispenserRent",
            component: cardDispenserRent,
            meta: {
                title: "访客车辆取卡",
                breadcrumb: [],
                isLogin: false
            }
        },
        {
            path: "/cardDispenserPerson1",
            component: cardDispenserPerson1,
            meta: {
                title: "访客人员取卡",
                breadcrumb: [],
                isLogin: false
            }
        },
        {
            path: "/submitSuccess",
            component: submitSuccess,
            meta: {
                title: "扫码通行",
                breadcrumb: []
            }
        },
        {
            path: "/",
            name: "登录1",
            component: Login,
            meta: {
                isLogin: false
            }
        },
        {
            path: "/login",
            name: "登录2",
            component: Login,
            meta: {
                isLogin: false
            }
        },
        {
            path: "/:tenant/login",
            name: "登录3",
            component: Login,
            meta: {
                isLogin: false
            }
        },
        {
            path: "/mapTest",
            name: "",
            component: mapTest,
            meta: {
                isLogin: true
            }
        },
        {
            path: "/Index_Sass",
            name: "大屏首页1",
            component: Index_Sass,
            meta: {
                isLogin: true
            }
        },
        {
            path: "/index",
            name: "大屏首页2",
            component: Index,
            meta: {
                isLogin: true
            }
        },
        {
            path: "/index_ue",
            name: "大屏首页3",
            component: Index_ue,
            meta: {
                isLogin: true
            }
        },
        {
            path: "/largeSize",
            name: "大屏首页4",
            component: largeSize,
            meta: {
                isLogin: false
            }
        },
        {
            path: "/index-2d",
            name: "大屏首页5",
            component: Index_2d,
            meta: {
                isLogin: true
            }
        },
        {
            path: "/index-2ds",
            name: "大屏首页6",
            component: Index_2ds,
            meta: {
                isLogin: true
            }
        },
        {
            path: "/CorporateGroupIndex",
            name: "CorporateGroupIndex",
            component: CorporateGroupIndex,
            meta: {
                isLogin: true,
                breadcrumb: [
                    {
                        text: "集团大屏",
                        path: "/CorporateGroupIndex"
                    }
                ]
            }
        },
        {
            path: "/main",
            name: "首页",
            component: Main,
            meta: {
                isLogin: true,
                breadcrumb: []
            },
            children: [
                {
                    path: "/index-set",
                    name: "大屏图表设置",
                    component: IndexSet,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "系统管理",
                                path: ""
                            },
                            {
                                text: "》大屏展示设置",
                                path: "/index-set"
                            }
                        ]
                    }
                },
                {
                    path: "/iframe",
                    name: "内嵌页面",
                    component: Iframe,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/userSet",
                    name: "用户设置",
                    component: userSet,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "首页",
                                path: ""
                            },
                            {
                                text: "》个人设置",
                                path: "/userSet"
                            }
                        ]
                    }
                },
                {
                    path: "/realtimeLocation",
                    name: "实时定位3D",
                    component: realtimeLocation,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/realTimePositioning",
                    name: "实时定位追踪",
                    component: realtimeLocationTracking,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/moreConfigurationSystem",
                    name: "系统自定义配置",
                    component: moreConfigurationSystem,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "首页  ",
                                path: "/realtimeLocation"
                            },
                            {
                                text: "》系统管理  ",
                                path: ""
                            },
                            {
                                text: "》系统自定义配置",
                                path: "/moreConfigurationSystem"
                            },
                        ]
                    }
                },
                {
                    path: "/moreConfigurationPerson",
                    name: "定位更多配置(个人)",
                    component: moreConfigurationPerson,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "定位更多配置(个人)",
                                path: "/moreConfigurationPerson"
                            }
                        ]
                    }
                },
                {
                    path: "/realtimeLocation_ue",
                    name: "实时定位UE",
                    component: realtimeLocation_ue,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/realtimeLocation_2d",
                    name: "实时定位2d",
                    component: realtimeLocation_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/realtimeLocation_2ds",
                    name: "实时定位2ds",
                    component: realtimeLocation_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/realtimeTrack",
                    name: "实时追踪",
                    component: realtimeTrack,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/realtimeTrack_ue",
                    name: "实时追踪UE",
                    component: realtimeTrack_ue,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/realtimeTrack-2d",
                    name: "实时追踪2D",
                    component: realtimeTrack_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                }, {
                    path: "/realtimeTrack-2ds",
                    name: "实时追踪2.5D",
                    component: realtimeTrack_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/hotMap",
                    name: "热力图3D",
                    component: hotMap,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/hotMap-2d",
                    name: "热力图2D",
                    component: hotMap_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/hotMap-2ds",
                    name: "热力图2.5D",
                    component: hotMap_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/riskMap",
                    name: "风险分区3D",
                    component: riskMap,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/riskMap_2d",
                    name: "风险分区2D",
                    component: riskMap_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/riskMap_2ds",
                    name: "风险分区2.5D",
                    component: riskMap_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/history",
                    name: "历史轨迹3D",
                    component: history,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/history-2d",
                    name: "历史轨迹2.5D",
                    component: history_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/history_ue",
                    name: "历史轨迹UE",
                    component: history_ue,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/userManage",
                    name: "用户管理",
                    component: userManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "用户管理",
                                path: "/userManage"
                            }
                        ]
                    }
                },
                {
                    path: "/menuManage",
                    name: "菜单管理",
                    component: menuManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "菜单管理",
                                path: "/menuManage"
                            }
                        ]
                    }
                },
                {
                    path: "/mapList",
                    name: "地图管理",
                    component: mapList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "地图管理",
                                path: "/mapList"
                            }
                        ]
                    }
                },
                {
                    path: "/mapConfig",
                    name: "地图配置",
                    component: mapConfig,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "地图配置",
                                path: "/mapConfig"
                            }
                        ]
                    }
                },
                {
                    path: "/beaconList",
                    name: "信标管理",
                    component: beaconList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "信标管理",
                                path: "/beaconList"
                            }
                        ]
                    }
                },
                {
                    path: "/beaconList_2d",
                    name: "信标管理-2D",
                    component: beaconList_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "信标管理",
                                path: "/beaconList_2d"
                            }
                        ]
                    }
                },
                {
                    path: "/beaconList_2ds",
                    name: "beaconList_2ds",
                    component: beaconList_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "信标管理",
                                path: "/beaconList_2ds"
                            }
                        ]
                    }
                },
                {
                    path: "/beaconManage",
                    name: "信标配置",
                    component: beaconManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "信标管理",
                                path: "/beaconList"
                            },
                            {
                                text: "》信标配置",
                                path: "/beaconManage"
                            }
                        ]
                    }
                },
                {
                    path: "/beaconManage_2d",
                    name: "信标配置_2d",
                    component: beaconManage_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "信标管理",
                                path: "/beaconList_2d"
                            },
                            {
                                text: "》信标配置",
                                path: "/beaconManage_2d"
                            }
                        ]
                    }
                },
                {
                    path: "/beaconManage_2ds",
                    name: "信标配置_2.5d",
                    component: beaconManage_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "信标管理",
                                path: "/beaconList_2ds"
                            },
                            {
                                text: "》信标配置",
                                path: "/beaconManage_2ds"
                            }
                        ]
                    }
                },
                {
                    path: "/buildingList",
                    name: "楼宇管理",
                    component: buildingList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "楼宇管理",
                                path: "/buildingList"
                            }
                        ]
                    }
                },
                {
                    path: "/layerList",
                    name: "楼层管理",
                    component: layerList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "楼层管理",
                                path: "/layerList"
                            }
                        ]
                    }
                },
                {
                    path: "/layerManage",
                    name: "楼宇配置",
                    component: layerManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "楼宇管理",
                                path: "/buildingList"
                            },
                            {
                                text: "》楼宇配置",
                                path: "/layerManage"
                            }
                        ]
                    }
                },
                {
                    path: "/stationList",
                    name: "基站管理3D",
                    component: stationList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "基站管理",
                                path: "/stationList"
                            }
                        ]
                    }
                },
                {
                    path: "/stationManage",
                    name: "基站配置",
                    component: stationManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "基站管理",
                                path: "/stationList"
                            },
                            {
                                text: "》基站配置",
                                path: "/stationManage"
                            }
                        ]
                    }
                },
                {
                    path: "/UWBstationList",
                    name: "UWB基站管理",
                    component: UWBstationList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "UWB基站管理",
                                path: "/UWBstationList"
                            }
                        ]
                    }
                },
                {
                    path: "/UWBstationManage",
                    name: "UWB基站管理3D",
                    component: UWBstationManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "UWB基站管理",
                                path: "/UWBstationList"
                            },
                            {
                                text: "》UWB基站配置",
                                path: "/UWBstationManage"
                            }
                        ]
                    }
                },
                {
                    path: "/UWBstationList_2ds",
                    name: "UWB基站管理2.5D",
                    component: UWBstationList_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "UWB基站管理",
                                path: "/UWBstationList_2ds"
                            }
                        ]
                    }
                },
                {
                    path: "/UWBstationManage_2ds",
                    name: "UWB基站管理1",
                    component: UWBstationManage_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "UWB基站管理",
                                path: "/UWBstationList_2ds"
                            },
                            {
                                text: "》UWB基站配置",
                                path: "/UWBstationManage_2ds"
                            }
                        ]
                    }
                },
                {
                    path: "/stationList_2d",
                    name: "基站管理2D",
                    component: stationList_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "基站管理",
                                path: "/stationList_2d"
                            }
                        ]
                    }
                },
                {
                    path: "/stationManage_2d",
                    name: "基站配置2.5D",
                    component: stationManage_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "基站管理",
                                path: "/stationList_2d"
                            },
                            {
                                text: "》基站配置",
                                path: "/stationManage_2d"
                            }
                        ]
                    }
                },
                {
                    path: "/cameraList",
                    name: "摄像头管理3D",
                    component: cameraList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "摄像头管理",
                                path: "/cameraList"
                            }
                        ]
                    }
                },
                {
                    path: "/cameraManage",
                    name: "摄像头配置3D",
                    component: cameraManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "摄像头管理",
                                path: "/cameraList"
                            },
                            {
                                text: "》摄像头配置",
                                path: "/cameraManage"
                            }
                        ]
                    }
                },
                {
                    path: "/cameraList_2d",
                    name: "摄像头管理2D",
                    component: cameraList_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "摄像头管理",
                                path: "/cameraList_2d"
                            }
                        ]
                    }
                },
                {
                    path: "/cameraManage_2d",
                    name: "摄像头配置2D",
                    component: cameraManage_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "摄像头管理",
                                path: "/cameraList_2d"
                            },
                            {
                                text: "》摄像头配置",
                                path: "/cameraManage_2d"
                            }
                        ]
                    }
                },
                {
                    path: "/railList",
                    name: "电子围栏管理3D",
                    component: railList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "电子围栏管理",
                                path: "/railList"
                            }
                        ]
                    }
                },
                {
                    path: "/railList_2ds",
                    name: "railList_2ds",
                    component: railList_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "电子围栏管理",
                                path: "/railList_2ds"
                            }
                        ]
                    }
                },
                {
                    path: "/railList_2d",
                    name: "电子围栏管理2D",
                    component: railList_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "电子围栏管理",
                                path: "/railList_2d"
                            }
                        ]
                    }
                },
                {
                    path: "/railManage",
                    name: "电子围栏配置3D",
                    component: railManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "电子围栏管理",
                                path: "/railList"
                            },
                            {
                                text: "》电子围栏配置",
                                path: "/railManage"
                            }
                        ]
                    }
                },

                {
                    path: "/railManage_2ds",
                    name: "电子围栏配置2D",
                    component: railManage_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "电子围栏管理",
                                path: "/railList_2ds"
                            },
                            {
                                text: "》电子围栏配置",
                                path: "/railManage_2ds"
                            }
                        ]
                    }
                },
                {
                    path: "/railManage_2d",
                    name: "railManage_2d",
                    component: railManage_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "围栏管理",
                                path: "/railList_2d"
                            },
                            {
                                text: "》电子围栏配置",
                                path: "/railManage_2d"
                            }
                        ]
                    }
                },
                {
                    path: "/riskList",
                    name: "风险分区管理",
                    component: riskList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "风险分区管理",
                                path: "/riskList"
                            }
                        ]
                    }
                },
                {
                    path: "/riskManage",
                    name: "风险分区配置3D",
                    component: riskManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "风险分区管理",
                                path: "/riskList"
                            },
                            {
                                text: "》风险分区配置",
                                path: "/riskManage"
                            }
                        ]
                    }
                },
                {
                    path: "/riskList_2d",
                    name: "重大风险分区管理",
                    component: riskList_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "重大风险分区管理",
                                path: "/riskList_2d"
                            }
                        ]
                    }
                },
                {
                    path: "/riskManage_2d",
                    name: "风险分区配置2D",
                    component: riskManage_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "风险分区管理",
                                path: "/riskList_2d"
                            },
                            {
                                text: "》风险分区配置",
                                path: "/riskManage_2d"
                            }
                        ]
                    }
                },
                {
                    path: "/roleManage",
                    name: "角色管理",
                    component: roleManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "角色管理",
                                path: "/roleManage"
                            }
                        ]
                    }
                },
                {
                    path: "/deptManage",
                    name: "部门管理",
                    component: deptManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "部门管理",
                                path: "/deptManage"
                            }
                        ]
                    }
                },
                {
                    path: "/positionManage",
                    name: "岗位管理",
                    component: positionManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "岗位管理",
                                path: "/positionManage"
                            }
                        ]
                    }
                },
                {
                    path: "/cardManage",
                    name: "定位卡管理",
                    component: cardManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "定位卡管理",
                                path: "/cardManage"
                            }
                        ]
                    }
                },
                {
                    path: "/dictManage",
                    name: "字典管理",
                    component: dictManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "字典管理",
                                path: "/dictManage"
                            }
                        ]
                    }
                },
                {
                    path: "/personAll",
                    name: "人员列表",
                    component: personAll,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "人员列表",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/staffManage",
                    name: "员工管理",
                    component: staffManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "员工管理",
                                path: "/staffManage"
                            }
                        ]
                    }
                },
                {
                    path: "/visitorManage",
                    name: "访客管理",
                    component: visitorManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "访客管理",
                                path: "/visitorManage"
                            }
                        ]
                    }
                },
                {
                    path: "/contractorManage",
                    name: "承包商管理",
                    component: contractorManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "承包商管理",
                                path: "/contractorManage"
                            }
                        ]
                    }
                },
                {
                    path: "/migrantManage",
                    name: "承包商作业人员管理",
                    component: migrantManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "承包商管理",
                                path: "/contractorManage"
                            },
                            {
                                text: "》承包商作业人员管理",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/loginLog",
                    name: "登录日志",
                    component: loginLog,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "登录日志",
                                path: "/loginLog"
                            }
                        ]
                    }
                },
                {
                    path: "/operLog",
                    name: "操作日志",
                    component: operLog,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "操作日志",
                                path: "/operLog"
                            }
                        ]
                    }
                },
                {
                    path: "/locationLog",
                    name: "定位日志",
                    component: locationLog,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "定位日志",
                                path: "/locationLog"
                            }
                        ]
                    }
                },
                {
                    path: "/alarmNoticeSet",
                    name: "报警通知设置",
                    component: alarmNoticeSet,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "报警通知设置",
                                path: "/alarmNoticeSet"
                            }
                        ]
                    }
                },
                {
                    path: "/sosAlarmNoticeSet",
                    name: "SOS报警通知设置",
                    component: sosAlarmNoticeSet,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "SOS报警通知设置",
                                path: "/sosAlarmNoticeSet"
                            }
                        ]
                    }
                },
                {
                    path: "/alarmPersonSet",
                    name: "人员报警设置",
                    component: alarmPersonSet,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "人员报警设置",
                                path: "/alarmPersonSet"
                            }
                        ]
                    }
                },
                {
                    path: "/alarmPsList",
                    name: "人员报警记录",
                    component: alarmPsList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "人员报警记录",
                                path: "/alarmPsList"
                            }
                        ]
                    }
                },
                {
                    path: "/systemInfo",
                    name: "系统信息",
                    component: systemInfo,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "系统信息管理",
                                path: "/systemInfo"
                            }
                        ]
                    }
                },
                {
                    path: "/statisticsAlarm",
                    name: "报警统计",
                    component: statisticsAlarm,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "统计管理",
                                path: ""
                            },
                            {
                                text: "》报警统计",
                                path: "/statisticsAlarm"
                            }
                        ]
                    }
                },
                {
                    path: "/statisticsPerson",
                    name: "人员统计",
                    component: statisticsPerson,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "统计管理",
                                path: ""
                            },
                            {
                                text: "》人员统计",
                                path: "/statisticsPerson"
                            }
                        ]
                    }
                },
                {
                    path: "/statisticsCar",
                    name: "车辆统计",
                    component: statisticsCar,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "统计管理",
                                path: ""
                            },
                            {
                                text: "》车辆统计",
                                path: "/statisticsCar"
                            }
                        ]
                    }
                },
                {
                    path: "/carManage",
                    name: "车辆管理",
                    component: carManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "车辆列表",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/visitorVehicle",
                    name: "车辆管理",
                    component: visitorVehicle,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "访客车辆记录",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/visitorVehicle",
                    name: "车辆管理",
                    component: visitorVehicle,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "访客车辆记录",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/alarmCarSet",
                    name: "车辆报警设置",
                    component: alarmCarSet,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "车辆报警设置",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/alarmCarList",
                    name: "车辆报警记录",
                    component: alarmCarList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "车辆报警记录",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/watchManage",
                    name: "手表管理",
                    component: watchManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "手表管理",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/termManage",
                    name: "巡检项管理",
                    component: termManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "巡检项管理",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/locationManage",
                    name: "locationManage",
                    component: locationManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "巡检点管理",
                                path: "/locationManage"
                            }
                        ],
                    }
                },
                {
                    path: "/locationDispose",
                    name: "locationDispose",
                    component: locationDispose,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "巡检点管理",
                                path: "/locationManage"
                            },
                            {
                                text: "》巡检点配置",
                                path: "/locationDispose"
                            }
                        ]
                    }
                },
                {
                    path: "/hiddenDangerManage",
                    name: "隐患管理",
                    component: hiddenDangerManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "隐患管理",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/patrolClassmanage",
                    name: "巡检类别管理",
                    component: patrolClassmanage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "巡检类别管理",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/patrolInspectionTeam",
                    name: "巡检班组管理",
                    component: patrolInspectionTeam,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "巡检班组管理",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/checkRouteManage",
                    name: "巡检路线管理",
                    component: checkRouteManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "巡检路线管理",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/inspectRecord",
                    name: "巡检记录",
                    component: inspectRecord,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "巡检记录",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/inspectHistory",
                    name: "巡检历史",
                    component: inspectHistory,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "巡检历史",
                                path: ""
                            }
                        ]
                    }
                },
                {
                    path: "/regionList",
                    name: "单区列表",
                    component: regionList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "单区列表",
                                path: "/regionList"
                            }
                        ]
                    }
                },
                {
                    path: "/manage-2d",
                    name: "新增单区列表",
                    component: regionManage_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "单区列表",
                                path: "/regionList"
                            },
                            {
                                text: "》新增单区列表",
                                path: "/manage-2d"
                            }
                        ]
                    }
                },
                {
                    path: "/manage",
                    name: "新增单区列表3D",
                    component: regionManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "单区列表",
                                path: "/regionList"
                            },
                            {
                                text: "》新增单区列表 ",
                                path: "/manage"
                            }
                        ]
                    }
                },
                {
                    path: "/car-history",
                    name: "车辆历史轨迹3D",
                    component: carHistory,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/carHistory-2d",
                    name: "车辆历史轨迹",
                    component: carHistory_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/alarmManage-2d",
                    name: "报警位置",
                    component: alarmManage_2d,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "报警位置", path: "" }]
                    }
                },
                {
                    path: "/alarmManage-2ds",
                    name: "报警位置2.5D",
                    component: alarmManage_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "报警位置", path: "" }]
                    }
                },
                {
                    path: "/typeManage",
                    name: "作业字典管理",
                    component: typeManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "作业字典管理", path: "" }]
                    }
                },
                {
                    path: "/configureManage",
                    name: "作业配置管理",
                    component: configureManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "作业配置管理", path: "" }]
                    }
                },
                {
                    path: "/examineManage",
                    name: "作业审批库",
                    component: examineManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "作业审批库", path: "" }]
                    }
                },
                {
                    path: "/taskRiskManage",
                    name: "风险识别管理",
                    component: taskRiskManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "风险识别管理", path: "" }]
                    }
                },
                {
                    path: "/safeManage",
                    name: "安全措施管理",
                    component: safeManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "安全措施管理", path: "" }]
                    }
                },
                {
                    path: "/urgentManage",
                    name: "应急措施管理",
                    component: urgentManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "应急措施管理", path: "" }]
                    }
                },
                {
                    path: "/analysis",
                    name: "JSA分析库",
                    component: analysis,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "JSA分析库", path: "" }]
                    }
                },

                {
                    path: "/deviceManage",
                    name: "监控设备管理",
                    component: deviceManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "监控设备管理", path: "" }]
                    }
                },
                {
                    path: "/recordManage",
                    name: "监控报警记录",
                    component: recordManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "监控报警记录", path: "" }]
                    }
                },
                {
                    path: "/workMAlarm",
                    name: "监控报警统计",
                    component: workMAlarm,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "监控报警统计", path: "" }]
                    }
                },
                {
                    path: "/videoAnalysis",
                    name: "videoAnalysis",
                    component: videoAnalysis,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "AI智能分析设备", path: "" }]
                    }
                },
                {
                    path: "/taskAnalyse",
                    name: "JSA作业安全分析",
                    component: taskAnalyse,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "JSA作业安全分析", path: "" }]
                    }
                },
                {
                    path: "/taskApply",
                    name: "taskApply",
                    component: taskApply,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "作业申请", path: "/taskApply" }],
                        keepAlive: true
                    }
                },
                {
                    path: "/examineList",
                    name: "待办审批",
                    component: examineList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "待办审批", path: "" }]
                    }
                },
                {
                    path: "/taskList",
                    name: "taskList",
                    component: taskList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [{ text: "作业列表", path: "" }],
                        keepAlive: true
                    }
                },
                {
                    path: "/trajectory",
                    name: "历史轨迹",
                    component: trajectory,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/personTime",
                    name: "时间点人员分布1",
                    component: personTime,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/personTime-2ds",
                    name: "时间点人员分布",
                    component: personTime_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: []
                    }
                },
                {
                    path: "/gateRecord",
                    name: "二道门进出记录",
                    component: gateRecord,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "统计管理",
                                path: ""
                            },
                            {
                                text: "》二道门进出记录",
                                path: "/gateRecord"
                            }
                        ]
                    }
                },
                {
                    path: "/attendanceRecord",
                    name: "考勤记录",
                    component: attendanceRecord,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "统计管理",
                                path: ""
                            },
                            {
                                text: "》考勤记录",
                                path: "/attendanceRecord"
                            }
                        ]
                    }
                },
                {
                    path: "/systemConfigura",
                    name: "系统配置",
                    component: systemConfigura,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "系统配置",
                                path: "/systemConfigura"
                            }
                        ]
                    }
                },
                {
                    path: "/statisticsInspect",
                    name: "统计分析",
                    component: statisticsInspect,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "统计分析",
                                path: "/statisticsInspect"
                            }
                        ]
                    }
                },
                {
                    path: "/carRecord",
                    name: "车辆通行记录",
                    component: carRecord,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "车辆通行记录",
                                path: "/carRecord"
                            }
                        ]
                    }
                },
                {
                    path: "/applyLocation",
                    name: "applyLocation",
                    component: applyLocation,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "作业预约申请",
                                path: ""
                            },
                            {
                                text: "》位置管理",
                                path: "/applyLocation"
                            }
                        ]
                    }
                },
                {
                    path: "/drawRail",
                    name: "drawRail",
                    component: drawRail,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "绘制区域",
                                path: "/drawRail"
                            }
                        ]
                    }
                },
                {
                    path: "/taskEvent",
                    name: "taskEvent",
                    component: taskEvent,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "作业活动预约",
                                path: "/taskEvent"
                            }
                        ]
                    }
                },
                {
                    path: "/drillPlan",
                    name: "drillPlan",
                    component: drillPlan,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "演练计划",
                                path: "/drillPlan"
                            }
                        ],
                    }
                },
                {
                    path: "/drillRecord",
                    name: "drillRecord",
                    component: drillRecord,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "演练记录",
                                path: "/drillRecord"
                            }
                        ]
                    }
                },
                {
                    path: "/emergencyArea",
                    name: "emergencyArea",
                    component: emergencyArea,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "应急区域",
                                path: "/emergencyArea"
                            }
                        ],
                    }
                },
                {
                    path: "/broadcast",
                    name: "broadcast",
                    component: broadcast,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "广播撤离",
                                path: "/broadcast"
                            }
                        ]
                    }
                },
                {
                    path: "/beaconGrouping",
                    name: "beaconGrouping",
                    component: beaconGrouping,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "信标分组",
                                path: "/beaconGrouping"
                            }
                        ]
                    }
                },
                {
                    path: "/groupingManage-2ds",
                    name: "groupingManage-2ds",
                    component: groupingManage_2ds,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "信标分组",
                                path: "/beaconGrouping"
                            },
                            {
                                text: "》信标分组配置",
                                path: "/groupingManage-2ds"
                            }
                        ]
                    }
                },
                {
                    path: "/areaList",
                    name: "areaList",
                    component: areaList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "区域列表",
                                path: "/areaList"
                            },
                        ]
                    }
                },
                {
                    path: "/personHistory",
                    name: "personHistory",
                    component: personHistory,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                        ]
                    }
                },
                {
                    path: "/lampList",
                    name: "灯具管理1",
                    component: lampList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "灯具管理",
                                path: "/lampList"
                            }
                        ]
                    }
                },
                {
                    path: "/lampGroup",
                    name: "灯组管理",
                    component: lampGroup,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "灯组管理",
                                path: "/lampGroup"
                            }
                        ]
                    }
                },
                {
                    path: "/luminanceTimeStatistics",
                    name: "亮灯时长统计",
                    component: TimeStatistics,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "亮灯时长统计",
                                path: "/亮灯时长统计"
                            }
                        ]
                    }
                },
                {
                    path: "/lampTask",
                    name: "时控任务",
                    component: lampTask,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "时控任务",
                                path: "/lampTask"
                            }
                        ]
                    }
                },
                {
                    path: "/lampAlarm",
                    name: "异常报警记录",
                    component: lampAlarm,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "异常报警记录",
                                path: "/lampAlarm"
                            }
                        ]
                    }
                },
                {
                    path: "/lampStatistics",
                    name: "灯具功耗统计",
                    component: lampStatistics,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "灯具功耗统计",
                                path: "/lampStatistics"
                            }
                        ]
                    }
                },
                {
                    path: "/lampManage",
                    name: "灯具管理",
                    component: lampManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "灯具管理",
                                path: "/lampList"
                            }
                        ]
                    }
                },
                {
                    path: "/cardDispenserManage",
                    name: "发卡机管理",
                    component: cardDispenserManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "发卡机管理",
                                path: "/cardDispenserManage"
                            }
                        ]
                    }
                },
                {
                    path: "/cardDispenserRecord",
                    name: "发卡机记录",
                    component: cardDispenserRecord,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "发卡机记录",
                                path: "/cardDispenserRecord"
                            }
                        ]
                    }
                },
                {
                    path: "/cardDispenserControl",
                    name: "发卡机运维管理",
                    component: cardDispenserControl,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "发卡机运维管理",
                                path: "/cardDispenserControl"
                            }
                        ]
                    }
                },
                {
                    path: "/cardDispenserPerson",
                    name: "发卡人员列表",
                    component: cardDispenserPerson,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "发卡人员列表",
                                path: "/cardDispenserPerson"
                            }
                        ]
                    }
                },
                {
                    path: "/cardIsuserStatus",
                    name: "车辆发卡状态",
                    component: cardIsuserStatus,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "车辆发卡状态",
                                path: "/cardIsuserStatus"
                            }
                        ]
                    }
                },
                {
                    path: "/cardRecord",
                    name: "车辆发卡记录",
                    component: cardRecord,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "车辆发卡记录",
                                path: "/cardRecord"
                            }
                        ]
                    }
                },
                {
                    path: "/recordPerson",
                    name: "人员发卡记录",
                    component: recordPerson,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "人员发卡记录",
                                path: "/recordPerson"
                            }
                        ]
                    }
                },
                {
                    path: "/areaRecord",
                    name: "区域进出记录",
                    component: areaRecord,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "区域进出记录",
                                path: "/areaRecord"
                            }
                        ]
                    }
                },
                {
                    path: "/onlineRate",
                    name: "onlineRate",
                    component: onlineRate,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "部门在线率",
                                path: "/onlineRate"
                            }
                        ]
                    }
                },
                {
                    path: "/messageLog",
                    name: "messageLog",
                    component: messageLog,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "短信日志",
                                path: "/messageLog"
                            }
                        ]
                    }
                },
                {
                    path: "/mapTools",
                    name: "mapTools",
                    component: mapTools,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "平面坐标工具",
                                path: "/mapTools"
                            }
                        ]
                    }
                },
                {
                    path: "/CGM",
                    name: "CGM",
                    component: CGM,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "集团管理",
                                path: "/CGM"
                            }
                        ]
                    }
                },
                {
                    path: "/CGC",
                    name: "CGC",
                    component: CGC,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "分公司管理",
                                path: "/CGC"
                            }
                        ]
                    }
                },
                {
                    path: "/turnstileManage",
                    name: "turnstileManage",
                    component: turnstileManage,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "闸机管理",
                                path: "/turnstileManage"
                            }
                        ]
                    }
                },
                {
                    path: "/sqlBack",
                    name: "数据备份",
                    component: sqlBack,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "数据备份",
                                path: "/sqlBack"
                            }
                        ]
                    }
                },
                {
                    path: "/tenantList",
                    name: "企业列表",
                    component: tenantList,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "企业列表",
                                path: "/tenantList"
                            }
                        ]
                    }
                },
                {
                    path: "/tenantDataSource",
                    name: "企业数据源管理",
                    component: tenantDataSource,
                    meta: {
                        isLogin: true,
                        breadcrumb: [
                            {
                                text: "企业数据源管理",
                                path: "/tenantDataSource"
                            }
                        ]
                    }
                },
            ]
        }
    ]
});




// WEBPACK FOOTER //
// ./src/router/index.js